'use client';

import { Button, Drawer as DrawerSparky, Icon, Logo } from '@petsmart-ui/sparky';
import type { Entry } from 'contentful';
import { useState } from 'react';

import { useCategoryStack } from '../../hooks';
import { DrawerMenuItem } from '../HeaderDrawerItem';
import type { HeaderDrawerProps } from './types';
import './HeaderDrawer.scss';

export function HeaderDrawer({ mainMenu, secondaryNavigation: _secondaryNavigation }: Readonly<HeaderDrawerProps>) {
    const [isActive, setisActive] = useState(false);
    const { handleBackClick, handleCategoryClick, categoryStack, currentCategories } = useCategoryStack(
        mainMenu?.fields?.category ? (mainMenu.fields.category as Entry[]) : []
    );

    return (
        <>
            {/* Reimplement menu button */}
            <Button
                data-testid="menu-button"
                className="sparky-c-header__menu-button"
                variant="bare"
                text={isActive ? 'Close' : 'Menu'}
                iconPosition="before"
                iconName={isActive ? 'x' : 'menu'}
                size="lg"
                hideText
                onClick={() => {
                    setisActive(true);
                }}
            />

            <DrawerSparky
                className="drawer"
                isActive={isActive}
                onClose={() => setisActive(false)}
                data-testid="header-drawer"
            >
                <DrawerSparky.Header>
                    {categoryStack.length > 1 ? (
                        <div className="header-drawer header-drawer--top">
                            <button
                                data-testid="back-button"
                                onClick={handleBackClick}
                                className="category__button--back category__button"
                                type="button"
                            >
                                <Icon size="lg" name="chevron-left" />
                                <span>{currentCategories.displayText}</span>
                            </button>
                        </div>
                    ) : (
                        <Logo />
                    )}
                </DrawerSparky.Header>
                {currentCategories.categories && (
                    <DrawerSparky.Body className="drawer-body">
                        <ul
                            data-testid="drawer-body"
                            className={`menu-category menu-category--lvl${categoryStack.length}`}
                        >
                            {currentCategories.categories
                                // NOTE: Remove duplicate categories to avoid phantom menu items on back button click
                                // TODO: should be remove if we can get the category stack to work properly with unique IDs
                                .filter(
                                    (category, index, self) => index === self.findIndex(c => c.sysId === category.sysId)
                                )
                                .map(category => (
                                    <DrawerMenuItem
                                        key={category.sysId}
                                        categoryStack={categoryStack}
                                        category={category}
                                        handleCategoryClick={handleCategoryClick}
                                        closeMenu={() => setisActive(false)}
                                    />
                                ))}
                        </ul>
                    </DrawerSparky.Body>
                )}
            </DrawerSparky>
        </>
    );
}
